import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import TruncateText from "../../components/common/TruncateText";
import { FileRole } from "./__generated__/AutomationTaskPageQuery.graphql";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";

const PREFIX = "FileTable";

const classes = {
  root: `${PREFIX}-root`,
  root2: `${PREFIX}-root2`,
  table: `${PREFIX}-table`,
  tableCell: `${PREFIX}-tableCell`,
};

const StyledPaper = styled(Paper)({
  [`& .${classes.root2}`]: {
    marginTop: "40px",
    marginBottom: "40px",
  },
  [`& .${classes.table}`]: {
    tableLayout: "fixed",
    wordWrap: "break-word",
  },
  [`& .${classes.tableCell}`]: {
    borderBottom: "none",
  },
});

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export interface FileTableProps {
  data?: ReadonlyArray<
    | {
        readonly node:
          | {
              readonly file:
                | {
                    readonly __typename: string;
                    readonly file_name?: string | null | undefined;
                    readonly file_url?: string | null | undefined;
                    readonly id?: string;
                  }
                | null
                | undefined;
              readonly file_id?: string | null | undefined;
              readonly role: FileRole;
              readonly thing_id?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined
  >;
}

const FileTable: React.FC<FileTableProps> = ({ data }: FileTableProps) => {
  return (
    <StyledPaper className={classes.root}>
      <Table stickyHeader size="small" className={classes.table}>
        <colgroup>
          <col style={{ width: "50%" }} />
        </colgroup>
        <TableHead>
          <AlternatingRow
            classes={{
              root: classes.root,
            }}
          >
            <TableCell>File</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Download</TableCell>
            <TableCell></TableCell>
          </AlternatingRow>
        </TableHead>
        <TableBody>
          {data?.map((e) => (
            <AlternatingRow
              key={e?.node?.file?.id}
              classes={{
                root: classes.root,
              }}
            >
              <TableCell className={classes.tableCell}>
                <TruncateText text={e?.node?.file?.file_name ?? ""} />
              </TableCell>
              <TableCell className={classes.tableCell}>{e?.node?.role}</TableCell>
              <TableCell className={classes.tableCell}>
                <Button href={e?.node?.file?.file_url ?? ""}>Download</Button>
              </TableCell>
              <TableCell className={classes.tableCell}>
                <Button component={Link} to={viewPath(e?.node?.file?.id)}>
                  more
                </Button>
              </TableCell>
            </AlternatingRow>
          ))}
        </TableBody>
      </Table>
    </StyledPaper>
  );
};

export default FileTable;
